<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain class="pb-0" maxwidth-container="700px">
      <CartoesStepper />
    </InternaMain>
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import CartoesStepper from '@/components/MeuPerfil/CartoesCredito/CartoesStepper.vue';

export default {
  name: 'CartoesCreditoCadastrar',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    CartoesStepper,
  },

  beforeRouteLeave(to, from, next) {
    // Ao sair do cadastro sem salvar (ex.: "voltar" do browser), descarta a intenção de
    // recobrança para não cobrar o cartão antigo (M1). No save confirmado, o stepper já
    // armou a recobrança e limpou a intenção antes de navegar.
    this.$store.dispatch('meuperfil/setRecobrarAposCadastro', null);
    this.$store.dispatch('meuperfil/setAssinaturaCadastrarCartao', false);
    next();
  },

  data() {
    return {
    };
  },
};
</script>
